import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminApi, apiError } from "./adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = signed out
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    adminApi
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false))
      .finally(() => setChecked(true));
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      setUser(data);
      return { ok: true };
    } catch (error) {
      return { ok: false, message: apiError(error) };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await adminApi.post("/auth/logout");
    } finally {
      setUser(false);
    }
  }, []);

  return (
    <AdminAuthContext.Provider value={{ user, checked, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (!context) throw new Error("useAdminAuth must be used inside AdminAuthProvider");
  return context;
}
